import {
  Button,
  Chip,
  CircularProgress,
  createStyles,
  Dialog,
  DialogActions,
  DialogContentText,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputBase,
  ListItemText,
  makeStyles,
  MenuItem,
  NativeSelect,
  Radio,
  RadioGroup,
  Select,
  Snackbar,
  Theme,
  Tooltip,
  Typography,
  withStyles,
} from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Divider from "@material-ui/core/Divider";
import * as React from "react";
import {useEffect, useState} from "react";
import AddNewDecoder from "src/app/setup-senzmatica/define-product-type-form/CreateCodec";
import {primaryBlue, primaryGray, primaryRed, searchBarBorderColor, white} from "src/components/colors";
import {TextBar} from "src/components/sub-components/TextBar";
import {environment} from "src/environments/environment";
import ReactSwitch from "react-switch";
import {AddIconLarge, ArrowIcon, CloseIcon, CloseIconColor, DownArrow, QuestionIcon, UpArrow} from "../../../components/Icons";
import axios from "axios";

import useStyles from "src/app/maintenance/assets/styles";
import { Alert } from "@material-ui/lab";
import { isStrictInteger,isCharValid,isNumeric, capitalizeWords } from "src/app/utils";
import { AuthService } from "src/app/authentication/auth.service";
import { addSensor, getAllSensors } from "src/app/maintenance/test-automation/components/apiHelper";
import { AddSensors } from "src/app/setup-senzmatica/define-product-type-form/AddSensorComponent";
import { hasPackagePermission } from "src/app/authentication/package.permission";
import { Close } from "@material-ui/icons";


export function EditProductType(props) {
  const classes = useLocalStyles();
  const style=useStyles();


  const [showSensorPopup, setShowSensorPopup] = useState(false);
  const [showActuatorPopup, setShowActuatorPopup] = useState(false);
  const [isTranscoding, setIsTranscoding] = useState(false);
  const [selectedSensor, setSelectedSensor] = useState('');
  const [selectedActuator, setSelectedActuator] = useState('');


  const [isCodecDropDown, setIsCodecDropDown] = useState(false);





  //Error Messages
  const [productNameError, setProductNameError] = useState(false);
  const [sensorsError, setSensorsError] = useState(false);
  const [showCreateCodecDialog, setShowCreateCodecDialog] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage,setSuccessMessage]=useState("Successfully updated!")
  const [open, setOpen] = useState(false);
  const [reqSuccess, setReqSuccess] = useState(true);


  const [loadingScreen, setLoadingScreen] = useState(false);
  const [openPrompt,setOpenPrompt]=useState(false);
  const [isAddSensorPopup,setIsAddSensorPopup] = useState(false)
  const [newSensorName,setNewSensorName] = useState("")
  const [newSensorCode,setNewSensorCode] = useState("")
  const [filteredSensors,setFilteredSensors] = useState([])
  const [showSensorOptions, setShowSensorOptions] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [sensorErrors,setSensorErrors] = useState({
    sensorNameError:null,
    sensorCodeError:null
  })
  
  const [errors, setErrors] = useState({
    productNameError: null,
    sensorsError: null,
    actuatorsError: null,
    protocolError: null,
    dataFormatError: null,
    connectivityError: null,
    persistenceError: null,
    parametersError:null,
    codecError:null
  })
  const[topicError,setTopicError]=useState("");
  const [upgradePopup, setUpgradePopup] = useState({
    open: false,
    featureName: ''
  });


  useEffect(() =>{
    setFilteredSensors(props.sensors)
  },[props.sensors])

  // Event listener to handle clicks outside dropdowns
  React.useEffect(() => {
    function handleClickOutside(event) {
      if (isCodecDropDown) {
        if (!event.target.closest('.codec-dropdown')) {
          setIsCodecDropDown(false);
        }
      }
    }

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [isCodecDropDown]);

  // Fetch MetaData from the API endpoint




//VALIDATIONS

const validateProductTypeForm = () => {
  let error: any = {}
  if (props.updatedProductName.trim() === "") {
    error.productNameError = "Product Name is Required"
  }

  if (props.sensorsOfDevice.length == 0 && props.actuatorsOfDevice.length == 0) {
    if (props.sensorsOfDevice.length == 0) {
      error.sensorsError = "Sensors are Required"
    }
    if (props.actuatorsOfDevice.length == 0) {
      error.actuatorsError = "Actuators are Required"
    }
  }

  if (props.updatedProtocol.trim() === "") {
    error.protocolError = "Protocol is Required"
  }

  
 if (props.updatedConnectivity.trim() === "") {
    error.connectivityError = "Connection is Required"
  }

  if (props.updatedPersistence === '') {
    error.persistenceError = "Persistence is Required"
  }
  if(props.isToggled && props.codecToSend===""){
      error.codecError = "Codec is Required"
  }
  
  return error

}






  //API endpoint for the update product type
  const updateProductType = async () => {
    try{
      checkTranscoding();
      const accessToken = AuthService.getAccessToken();
     
    
      const updatedData = 
       {id: props.id,
        productName: props.updatedProductName,
        connectivity: props.updatedConnectivity,
        protocol: props.updatedProtocol,
        persistence: props.updatedPersistence,
        sensorCodes: props.sensorCodesOfDevice,
        actuatorCodes: props.actuatorCodesOfDevice,
        codecName: props.codecToSend,
        transcoder: props.isToggled ? true : false,
      };

       setLoadingScreen(true);
      const response =await axios.put(`${environment.host}/core/product/productType/${props.id}`, updatedData, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      })
   
        const updatedProductType = response.data;
        
        if (response.data.errorCode && response.data.errorCode.length > 0) {

        setReqSuccess(false);
        setOpen(true);
        setErrorMessage(response.data.message);
        setLoadingScreen(false); 
        setTimeout(() => {
          setOpen(false);
          setErrorMessage("");
        }, 6000);
      } else {
        setReqSuccess(true);
        setSuccessMessage("Product Type Updated Successfully")
        setLoadingScreen(false);

        if (props.onUpdateSuccess) {
          props.onUpdateSuccess("Product Type Updated Successfully");
        }

        props.getAllProducts();
        props.onClose();
      }
        
    }
    catch(error) {
        console.error('Error updating product type:', error);
        setLoadingScreen(false);
        throw error;
      };
  };

  // Fetch product types from the API endpoint



  const handleConnectivityChange = (event) => {
    props.setUpdatedConnectivity(event.target.value);
  };
  const handleProtocolChange = (event) => {
    props.setUpdatedProtocol(event.target.value);
  };
  const handlePersistenceChange = (event) => {
    const newPersistenceValue = event.target.value === "true";
    props.setUpdatedPersistence(newPersistenceValue);
  };

  const handleSensorPopup = () => {
    setIsAddSensorPopup(!isAddSensorPopup);
    setSensorErrors((prev)=>({
      ...prev,
      sensorCodeError:null,
      sensorNameError:null
    }))
  };

  const handleSensorSelection = (sensor) => {
    const selectedSensorName = sensor;
    if (selectedSensorName === 'AddSensor') {
      handleSensorPopup();
    } else if(selectedSensorName !== "") {
      const selectedSensor = props.sensors.find(sensor => sensor.codeValue === selectedSensorName);
      if (selectedSensor && !props.sensorsOfDevice.some(sensor => sensor.codeValue === selectedSensor.codeValue)) {
        props.setSensorsOfDevice(prevSensors => [
          ...prevSensors,
          selectedSensor
        ]);
        props.setSensorCodesOfDevice(prevSensors => [...prevSensors, selectedSensor.code]);
      }
      setSensorsError(false);
    }
  };

  const isAddSensor = () =>{
    setShowSensorOptions(!showSensorOptions)
    setIsAddSensorPopup(false)
  }

  const removeSensorFromDevice = (indexToRemove) => {
    props.setSensorsOfDevice(prevSensors => {
      const updatedSensors = [...prevSensors];
      updatedSensors.splice(indexToRemove, 1); // Remove the sensor at the specified index
      return updatedSensors;
    });
    props.setSensorCodesOfDevice(prevSensorCodes => {
      const updatedSensorCodes = [...prevSensorCodes];
      updatedSensorCodes.splice(indexToRemove, 1); // Remove the sensor code at the specified index
      return updatedSensorCodes;
    });
  };

  const handleActuatorSelection = (event) => {
    const selectedActuatorName = event.target.value;
    if (selectedActuatorName === 'AddActuator') {
      setShowActuatorPopup(true);
    } else {
      const selectedActuator = props.actuators.find(actuator => actuator.name === selectedActuatorName);
      if (selectedActuator && !props.actuatorsOfDevice.includes(selectedActuatorName)) {
        props.setActuatorsOfDevice(prevActuators => [...prevActuators, selectedActuatorName]);
        props.setActuatorCodesOfDevice(prevActuatorCodes => {
          if (!Array.isArray(prevActuatorCodes)) {
            prevActuatorCodes = []; // Initialize as an empty array if not already defined
          }
          return [...prevActuatorCodes, selectedActuator.code];
        });
      }
      setSelectedActuator('');
    }
  };

  const removeActuatorFromDevice = (indexToRemove) => {
    props.setActuatorsOfDevice(prevActuators => {
      const updatedActuators = [...prevActuators];
      updatedActuators.splice(indexToRemove, 1);
      return updatedActuators;
    });
    props.setActuatorCodesOfDevice(prevActuatorCodes => {
      const updatedActuatorCodes = [...prevActuatorCodes];
      updatedActuatorCodes.splice(indexToRemove, 1);
      return updatedActuatorCodes;
    });
  };

  const handleDataFormatChange = (event) => {
    props.setUpdatedDataFormat(event.target.value);
  };

  const handleChangeOTAToggle = () => {
    if (!props.updatedOtaUpgradable && !hasPackagePermission("OTAManager")) {
      setUpgradePopup({
        open: true,
        featureName: 'OTA'
      });
    } else {
      props.setUpdatedOtaUpgradable(!props.updatedOtaUpgradable)
    }
  }

  const handleChangeRemoteToggle = () => {
    if (!props.updatedRemotelyConfigurable && !hasPackagePermission("RemoteManager")) {
      setUpgradePopup({
        open: true,
        featureName: 'Remote Manager'
      });
    } else {
      props.setUpdatedRemotelyConfigurable(!props.updatedRemotelyConfigurable);
    }
  };



  const handleCodecChange = (option) => {
    props.setCodecToSend(option);
  };
  const handleChangeToggle = () => {
    handleTranscoding();
    props.setIsToggled(!props.isToggled)
    setIsCodecDropDown(false);
    props.setSelectedCodec("");
    props.setCodecToSend("");
    props.setStep("select");
  }
  const handleTranscoding = () => {
    if (props.isToggled) {
      setIsTranscoding(true);
    }
  }
  const checkTranscoding = () => {
    if (isTranscoding) {
      props.setUpdatedCodecName(props.updatedCodecName);
      if (props.step === "create" && props.codecName.trim() !== "") {
        props.setUpdatedCodecName(props.codecName);
      }
    }
  }
  const handleCreateCodecClick = () => {
    props.setStep("create");
    setShowCreateCodecDialog(!showCreateCodecDialog);
  };
  const handleSelectCodecClick = () => {
    props.setStep("select");
    props.setSelectedCodec("");
    props.fetchCodecs();
  };
  const handleCodecCreation = (name) => {
    props.setCodecToSend(name);
  };
  const ActuatorPopup = () => {
    return (
      <Popup
        type="actuator"
        onClose={() =>
          setShowActuatorPopup(false)
        }/>
    );
  };
  const Popup = ({type, onClose}) => {
    return (
      <div style={{color: 'black'}}>
        <p>
          Need to add a {type === 'sensor' ? 'sensor' : 'actuator'}? <br/>
          Contact the admin for assistance!
        </p>
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '0px',
            right: '5px',
            backgroundColor: 'transparent',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          <CloseIcon color='#2A7BEC'/>
        </button>
      </div>
    );
  };

  const sensorValidation = () =>{
    let errors :any = {}
    if(newSensorName == ""){
      errors.sensorNameError = 'Sensor name required'
    }else if(props.sensors.some(sensor => sensor.codeValue.toLowerCase() === newSensorName.toLowerCase())){
      errors.sensorNameError = 'Sensor name already exist'
    }
    if(newSensorCode == ""){
      errors.sensorCodeError = 'Sensor code required'
    }else if(props.sensors.some(sensor => sensor.code.toLowerCase() === newSensorName.toLowerCase())){
      errors.sensorCodeError = 'Sensor code already exist'
    }
    return errors
  }

  const handleSensorName = (event) =>{
    const value = event.target.value
    setNewSensorName(value)
    if(value != ""){
      setSensorErrors((prev) =>({
        ...prev,
        sensorNameError : null
      }))
    }
  }

  const handleSensorCode = (event) =>{
    const value = event.target.value
    setNewSensorCode(value)
    if(value != ""){
      setSensorErrors((prev) =>({
        ...prev,
        sensorCodeError : null
      }))
    }
  }


    const getAllSensores =async () =>{
        try{
          const response =await getAllSensors()
          if(response){
            const sortedSensors = response.sort((a, b) => (a.codeValue < b.codeValue ? -1 : 1));
            props.setSensors(sortedSensors);
            setFilteredSensors(sortedSensors);
          }
        }catch(error){
          setOpen(true)
          setReqSuccess(false)
          setErrorMessage(error.message)
        }
    }
  
    const handleAddSensor = async() =>{
      const isValid = await sensorValidation();
      if(Object.values(isValid).length != 0){
        setSensorErrors(isValid)
        return;
      }
        setLoadingScreen(true)
      const data =[{
        code:newSensorCode.toUpperCase(),
        codeValue : capitalizeWords(newSensorName)
      }]
      console.log(data)
      try{
        const response = await addSensor(data)
        if(response){
          getAllSensores()
          setIsAddSensorPopup(false)
        }
      }catch(error){
        setOpen(true)
        setReqSuccess(false)
        setErrorMessage(error.message)
      }finally{
        setLoadingScreen(false)
      }
    }

  const handleSave = async () => {
    const validationError = validateProductTypeForm()
    setErrors(validationError)
    if (Object.keys(validationError).length > 0) {
      return;
    }
    
    let rmConfigSatisfied=!props.updatedRemotelyConfigurable||props.devices.length==0;    //if no devices in product type allow without configuring any
    let otaConfigSatisfied=!props.updatedOtaUpgradable||props.devices.length==0;
    
    props.devices.forEach(device=>{
      if (!rmConfigSatisfied&&device.rmConfigured=="Configured"){
        rmConfigSatisfied=true;
      }
      if (!otaConfigSatisfied&&device.otaConfigured=="Configured"){
        otaConfigSatisfied=true;
      }
      if(rmConfigSatisfied&&otaConfigSatisfied){return;}
    })
   if(!rmConfigSatisfied||!otaConfigSatisfied){
    setTopicError("When enabling 'Remote Manager' or 'OTA' for the first time, please configure at least one device under the product type before updating.");
    setOpenPrompt(true);
    return
   }
    try {
      await updateProductType();
   
       

    } catch (error) {
      console.error('Error updating product type:', error);
      setReqSuccess(false);
      setOpen(true);
      if(error.response.data.message){
      setErrorMessage(error.response.data.message);
      }
      setTimeout(() => {
        setOpen(false);
        setErrorMessage("");
      }, 6000);
    }
  };

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    if (query === '') {
      setFilteredSensors(props.sensors);
    } else {
      const filtered = props.sensors.filter(sensor => sensor.codeValue.toLowerCase().includes(query.toLowerCase()));
      setFilteredSensors(filtered);
    }
  };

  const UpgradePopup = ({ 
    open, 
    onClose, 
    onUpgrade,
    featureName,
    onCloseWithFeature
  }) => {
    return (
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{
          style: {
            width: '512px',
            maxWidth: '512px',
          },
        }}
      >
        <DialogTitle>
          <Grid container justifyContent="flex-end" alignItems="center">
            <IconButton onClick={onClose} size="small">
              <Close />
            </IconButton>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" style={{ marginBottom: '15px' }}>
            You've just configured a feature available only in the Basic package. To perform {featureName} operations, please upgrade your plan.
          </Typography>
          <Grid container justifyContent="flex-end" spacing={1}>
            <Grid item>
              <Button
                variant="contained"
                onClick={onUpgrade}
                className={style.buttonContained}
                style={{ backgroundColor: '#2A7CED', color: '#FFFFFF' }}
              >
                Upgrade Now
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                onClick={onCloseWithFeature}
                className={style.buttonOutlined}                
              >
                OK
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    );
  };

  
  const handleClose = (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (reason === 'backdropClick') {
      return; // to avoid closing popup during  backdrop click 
    }
    props.onClose(); 
  };
  return (
    <div>
      <Dialog
        open={props.open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth={"md"}
        BackdropProps={{
          style: {
            backgroundColor: "cubic-bezier(0.4, 0, 0.1, 1)",
            opacity: "0.2",
          },
        }}
        PaperProps={{
          style: {
            boxShadow: "inherit",
            maxWidth:"660px"
          },
        }}
      >
        <Grid
          container
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            opacity: "1",
            boxShadow: "0px 4px 30px #00000008",
          }}
        >
          <Grid item xs={10} md={10}>
            <DialogTitle>Edit Product Type</DialogTitle>
          </Grid>
          <Grid item xs={2} md={2} style={{ textAlign: "right" }}>
            <IconButton
              onClick={props.onClose} >
              <CloseIconColor />
            </IconButton>
          </Grid>
        </Grid>
        <Divider/>
        <>
          <DialogContent>
             <Grid container alignItems="center" justifyContent="center">
              <Grid item xs={6} md={6}
                    className={classes.gridStyle}
              >
                <Typography className={classes.labelStyle}>
                  Product Name :
                </Typography>
                <FormControl className={style.input}>
                    <input
                      className={style.formInput}
                      onChange={(e) => {
                        props.setUpdatedProductName(e.target.value);
                      }}
                      value={
                        props.updatedProductName
                      }
                    />
                  </FormControl>
                  {errors.productNameError && (
                  <span className="form-error">
                    {errors.productNameError}
                  </span>
                )}
              </Grid>
              <Grid item xs={6} md={6} className={classes.gridStyle}>
                <Typography className={classes.labelStyle}>
                  Protocol :
                </Typography>
             
                <FormControl className={style.input}>
                  <select
                    className={style.formInput}
                    value={props.updatedProtocol}
                    onChange={handleProtocolChange}
                  >
                    <option value={props.updatedProtocol}>{props.updatedProtocol}</option>
                    {props.updatedProtocol !== 'MQTT' && <option value="MQTT">MQTT</option>}
                    {hasPackagePermission('Protocol') && props.updatedProtocol !== 'HTTP' && <option value="HTTP">HTTP</option>}
                  </select>
                </FormControl>
                {errors.protocolError && (
                  <span className="form-error">
                    {errors.protocolError}
                  </span>
                )}
              </Grid>


              <Grid item xs={6} md={6} className={classes.gridStyle}>
                <Typography className={classes.labelStyle}>
                  Persistence :
                </Typography>
     
                <FormControl className={style.input}>
                    <select
                      className={style.formInput}
                      value={props.updatedPersistence.toString()}
                      onChange={handlePersistenceChange}
                    >
                      <option value={props.updatedPersistence.toString()}>
                        {props.updatedPersistence === true ? "Yes" : "No"}
                      </option>
                      {props.updatedPersistence== false && <option value="true">Yes</option>}
                      {props.updatedPersistence == true && <option value="false">No</option>}
                </select>
                                    
                </FormControl>
                {errors.persistenceError && (
                  <span className="form-error">
                    {errors.persistenceError}
                  </span>
                )}
              </Grid>

              <Grid item xs={6} md={6} className={classes.gridStyle}>
                <Typography className={classes.labelStyle}>
                  Connectivity :
                </Typography>
   
                <FormControl className={style.input}>
                  <select
                    className={style.formInput}
                    value={props.updatedConnectivity}
                    onChange={handleConnectivityChange}
                  >
                    <option value={props.updatedConnectivity}>{props.updatedConnectivity}</option>
                    {props.updatedConnectivity !== 'WIFI' && <option value="WIFI">Wifi</option>}
                    {props.updatedConnectivity !== 'GSM' && <option value="GSM">GSM</option>}
                  </select>
                </FormControl>
                {errors.connectivityError && (
                  <span className="form-error">
                    {errors.connectivityError}
                  </span>
                )}

              </Grid>

              <Grid item xs={12} md={12}
                    className={classes.gridStyle}
              >
                <Typography className={classes.labelStyle}>
                  Sensors :
                </Typography>
             <Grid item xs={12} md={12}
                    className={`${style.cloudContainer} ${showSensorPopup ? classes.popup : ''}`}
                    style={{marginBottom: "10px"}}>
                {/* {props.sensorsOfDevice.length === 0 && (
                  <label className="no-data-available"
                         style={{width: "100%"}}>
                    {showSensorPopup ? (
                      <SensorPopup/>
                    ) : (
                      <> </>
                    )}
                  </label>
                )} */}
                {props.sensorsOfDevice&&props.sensorsOfDevice.map((sensor, index) => (
                  <Grid container key={index}  className={style.cloudItem}>
                  <Grid item className={style.cloudItem_number}>{index + 1}</Grid>
                  <Grid item className={style.cloudItem_line}></Grid>
                  <Grid item className={style.cloudItem_text}>{sensor&&sensor.codeValue}</Grid>
                  <Grid item onClick={() => removeSensorFromDevice(index)} className={style.cloudItem_close}><CloseIcon color='#2A7BEC'/></Grid>
                </Grid>
                ))}
              </Grid>
              <Grid item xs={12} md={12} style={{marginBottom: "22px"}}>
                    <FormControl className={`${style.input} sensor-dropdown`}>
                                        <div className={style.formInput} onClick={isAddSensor}>
                                          <span style={{color: "grey"}}>
                                            {showSensorOptions ? (
                                              <InputBase
                                                placeholder="Search Sensors"
                                                style={{ fontFamily: "'Poppins',sans-serif", fontSize: '13px' }}
                                                value={searchQuery}
                                                onChange={handleSearchChange}
                                                fullWidth
                                                autoFocus
                                              />
                                            ) : (
                                              <>Add Sensors</>
                                            )}
                                          </span>
                                          {showSensorOptions ? <UpArrow /> : <DownArrow />}
                                        </div>
                                        {showSensorOptions && (
                                          <Grid container className={classes.dropDownGrid}>
                                            <Grid item xs={12} md={12}
                                                  className={style.option}
                                                  onClick={handleSensorPopup}
                                            >
                                              <div className={classes.addIcon}>
                                                <AddIconLarge/>
                                                <span style={{marginLeft: '5px'}}> Add Sensors </span>
                                              </div>
                                            </Grid>
                                            {isAddSensorPopup && 
                                              <AddSensors 
                                                sensorNameChange={handleSensorName} 
                                                sensorCodeChange={handleSensorCode} 
                                                handleSave={handleAddSensor}
                                                error = {sensorErrors}
                                              />
                                            }
                                            {filteredSensors.map((sensor, index) => (
                                              <Grid item xs={12} md={12}
                                                    className={style.option}
                                                    key={index}
                                                    onClick={() => handleSensorSelection(sensor.codeValue)}
                                              >
                                                <span style={{ marginLeft: '10px' }}> {sensor.codeValue} </span>
                                              </Grid>
                                            ))}
                                          </Grid>
                                        )}
                                        {errors.sensorsError && (
                                          <span className="form-error">
                                            {errors.sensorsError}
                                          </span>
                                        )}
                                      </FormControl>
              </Grid>
          </Grid>

              <Grid item xs={12} md={12} className={classes.gridStyle}>
                <Typography className={classes.labelStyle}>
                  Actuators :
                </Typography>
              <Grid item xs={12} md={12}
                    className={`cloud-container ${showActuatorPopup ? classes.popup : ''}`}
                    style={{marginBottom: "10px"}}>
                {props.actuatorsOfDevice.length === 0 && (
                  <label className="no-data-available" style={{width: "100%"}}>
                    {showActuatorPopup ? (
                      <ActuatorPopup/>
                    ) : (
                      <>  </>
                    )}
                  </label>
                )}
                {props.actuatorsOfDevice.map((actuator, index) => (
                <Grid container key={index}  className={style.cloudItem}>
                  <Grid item className={style.cloudItem_number}>{index + 1}</Grid>
                  <Grid item className={style.cloudItem_line}></Grid>
                  <Grid item className={style.cloudItem_text}>{actuator}</Grid>
                  <Grid item onClick={() => removeActuatorFromDevice(index)} className={style.cloudItem_close}><CloseIcon color='#2A7BEC'/></Grid>
                </Grid>
                ))}
              </Grid>
              <Grid item xs={12} md={12} style={{marginBottom: "22px"}}>
                {!showActuatorPopup && (
                  <>
                    <FormControl className={style.input}>
                      <select
                        value={selectedActuator}
                        onChange={handleActuatorSelection}
                        className={style.formInput}
                      >
                        <option value="" disabled hidden>Add Actuators</option>
                        <option value="AddActuator">Add Actuator</option>
                        {props.actuators.map((actuator, index) => (
                          <option key={index} value={actuator.name}>
                            {actuator.name}
                          </option>
                        ))}
                      </select>

                      {errors.actuatorsError && (
                  <span className="form-error">
                    {errors.actuatorsError}
                  </span>
                )}
                    </FormControl>
                  </>
                )}
              </Grid>
              </Grid>

              {/* {(props.updatedOtaUpgradable || props.updatedRemotelyConfigurable) && (
                <>
                <Grid container style={{justifyContent:"space-between"}}>
                  <Grid item xs={6} md={6} className={classes.gridStyle} >
                    <Typography className={classes.labelStyle}>
                      Data Format:
                    </Typography>
                    <FormControl className={style.input}>
                      <select
                        className={style.formInput}
                        value={props.updatedDataFormat}
                        onChange={handleDataFormatChange}
                      >
                        <option value={props.updatedDataFormat}>{props.updatedDataFormat}</option>
                        {props.updatedDataFormat !== "String" && <option value="String">String</option>}
                        {props.updatedDataFormat !== "Json" && <option value="Json">Json</option>}
                      </select>
                    </FormControl> 
                    {errors.dataFormatError && (
                  <span className="form-error">
                    {errors.dataFormatError}
                  </span>
                )}
                  </Grid>
                  <Grid item xs={5} md={5} className={classes.gridStyle} style={{display:"flex",justifyContent:"flex-end",alignItems:"flex-end"}}>
                    <Button
                      variant="contained"
                      onClick={props.toggleDeviceView}
                      className={classes.configDevicesButton}
                      style={{ textTransform: "none" }}
                    >
                      Configure Devices

                      <ArrowIcon width="20" height="15" />

                    </Button>
                  </Grid>
                  </Grid>
         </>
              )}  */}
              <Grid item xs={12} md={12} className={classes.gridStyle} 
              style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}>
                
                <Typography className={classes.labelStyle}>
                  Transcoding :
                </Typography>
              
                <Grid item xs={3} md={3} style={{
                  display: 'flex',
                  justifyContent: 'flex-end'
                }}>
                  <FormControl>
                    <ReactSwitch
                      checked={props.isToggled}
                      onChange={handleChangeToggle}
                      offColor='#D9D9D9'
                      onColor="#5F9DF2"
                      offHandleColor='#D9D9D9'
                      onHandleColor="#2A7BEC"
                      height={15}
                      width={40}
                      handleDiameter={20}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      
                    />
                  </FormControl>
                </Grid>
               
              </Grid> 
              {errors.codecError && (
                  <span className="form-error">
                    {errors.codecError}
                  </span>
                )}
              {props.isToggled && (
                <Grid container>
                  <Grid container style={{marginBottom: "22px"}}>
                    <Grid item xs={6} md={6}
                          onClick={handleSelectCodecClick}
                          className={`${style.formInput} ${style.switchTab}`}
                          style={{
                            borderBottom: props.step === "select" ? "3px solid #2A7CED" : "1px solid #ccc",
                          }}
                    >
                      <div> Select Codec Method</div>
                    </Grid>
                    <Grid item xs={6} md={6}
                          onClick={handleCreateCodecClick}
                          className={`${style.formInput} ${style.switchTab}`}
                          style={{
                            borderBottom: props.step === "create" ? "3px solid #2A7CED" : "1px solid #ccc",
                          }}
                    >
                      <div> Create Codec</div>
                    </Grid>
                  </Grid>

                  {/* create codec form elements */}
                  {props.step === 'create' && (
                    <AddNewDecoder
                      onClose={handleSelectCodecClick}
                      codecs={props.codecs}
                      onCodecToPlaceholder={handleCodecCreation}
                    />
                  )}

                  {/* select codec form elements */}
                  {props.step !== 'create' && (
                    <Grid container style={{marginBottom: "22px"}}>
                      <FormControl className={style.input}>
                        <Grid container style={{height: '40px'}}>
                          <Grid container className={style.formInput}
                                style={{cursor: 'pointer'}}
                                alignContent='center'
                                onClick={() => setIsCodecDropDown(true)}
                          >
                            <Grid item style={{flex: 1}}>
                              <input
                                placeholder={props.codecToSend === '' ? "Select Codec" : props.codecToSend}
                                className={style.optionInput}
                                defaultValue={props.selectedCodec}
                                readOnly
                              />
                            </Grid>
                            <Grid item> {isCodecDropDown ? <UpArrow/> : <DownArrow/>} </Grid>
                          </Grid>
                          {isCodecDropDown && (
                            <div style={{width: '100%', zIndex: 1}}>
                              <div className={classes.dropdown}>
                                {props.codecs.map((codec, index) => {
                                  return (
                                    <Grid item xs={12} md={12}
                                          className={classes.option}
                                          key={index}
                                          onClick={() => {
                                            handleCodecChange(codec.codecName)
                                          }}
                                    >
                                      <span style={{marginLeft: '10px'}}> {codec.codecName} </span>
                                    </Grid>
                                  )
                                })
                                }
                              </div>
                              <div style={{marginTop: '20px'}}/>
                            </div>
                          )}
                        </Grid>
                      </FormControl>
                    </Grid>
                  )}
                </Grid>
              )}




              </Grid>

            <DialogActions>
              <Button
                variant="contained"
                color="primary"
                style={{
                  color: 'white',
                  borderRadius: '8px',
                  boxShadow: 'none',
                  backgroundColor: primaryBlue,
                }}
                onClick={handleSave}
              >
                Update
              </Button>
            </DialogActions>
          </DialogContent>
        </>
      </Dialog>


      {/* {addParameter||addCommand ? (
        // ***** This is add new parameter input filed set ***** //
        <>
         <Dialog open={addParameter||addCommand} maxWidth="md" fullWidth>
           <Grid container>
              <Grid item xs={10} md={10}>
                
                <DialogTitle>
                  {type === "view" ? "View" : type === "edit" ? "Edit" : "Add"}{" "}
                  {addParameter ? "Parameter" : addCommand?"Command": "Firmware"}
                </DialogTitle>
                
              </Grid>
              <Grid item xs={2} md={2} style={{textAlign: "right"}}>
                <IconButton
                  onClick={() => {
                    addParameter ? closeAddParameter() : "";
                  }}
                >
                  <CloseIconColor/>
                </IconButton>
              </Grid>
            </Grid> */}
         
     
          {/* <DialogContent> */}
          {/* {addParameter&&
                <Grid container style={{ textAlign: "center", marginTop: "20px" }}>
                                          <Grid item xs={6} style={{ textAlign: "left", paddingBottom: "20px" }}>
                                            <Typography className={style.typo}>Parameter name<span className={style.required}>*</span> </Typography>
                                            <FormControl className={style.input}>
                                              <DropDownRMOTA
                                                isSingle={true}
                                                options={allParameters}
                                                type="parameter"
                                                placeholder="Select Parameter Name"
                                                value={type === "view" ? props.parameters[index].name : parameter}
                                                setSelectValue={v => setParameter(v.target.value)}
                                                disabled={type === "view"}
                                                onClick={handleParameterSelect}
                                                handleParameterCreate={handleParameterCreate}
                                              />
              
              
                                            </FormControl>
                                            {parameterError.error && (
                                              <Typography className={style.errorText}>{parameterError.errorMsg}</Typography>)}
                                          </Grid>
                                          <Grid item xs={6} md={6} style={{ textAlign: "left", paddingBottom: "20px", paddingLeft: "20px" }}>
                                            <Typography className={style.typo}>Parameter ID<span className={style.required}>*</span></Typography>
                                            <FormControl className={style.input}>

                                                <input
                                                  className={style.formInput}
                                                  disabled={type === "view" }
                                                  type="number"
                                                  value={id}
                                                  onChange={(e) => {
                                                    setId(e.target.value);
                                                    setIdError({ error: false, errorMsg: "" });
                                                  }}
                                                />
                                              
                                            </FormControl>
                                            {idError.error && (
                                              <Typography className={style.errorText}>{idError.errorMsg}</Typography>)}
                                          </Grid>
                                          <Grid item xs={6} md={6} style={{ textAlign: "left", paddingBottom: "20px"}}>
                                            <Typography className={style.typo}>Label<span className={style.required}>*</span></Typography>
                                            <FormControl className={style.input}>
                                                <input
                                                  className={style.formInput}
                                                  disabled={type === "view"}
                                                  value={label}
                                                  onChange={(e) => {
                                                    setLabel(e.target.value);
                                                    setLabelError({ error: false, errorMsg: "" });
                                                  }}
                                                />
                                            </FormControl>
                                            {labelError.error && (
                                              <Typography className={style.errorText}>{labelError.errorMsg}</Typography>)}
                                          </Grid>
                                          <Grid
                                            item
                                            xs={6}
                                            md={6}
                                            style={{ textAlign: "left", paddingBottom: "20px" ,paddingLeft:"20px"}}
                                          >
                                            <Typography className={style.typo}>Input Type<span className={style.required}>*</span></Typography>
                                            <FormControl className={style.input}>
                                              <Grid container style={{ height: '40px' }}>
                                                <Grid container className={style.formInput}
                                                  style={{ cursor: 'pointer' }}
                                                  alignContent='center'
                                                  onClick={() => {  if (parameterToCreate||type=="edit") { setIsInputTypeDropDown(!isInputTypeDropDown) } }}
                                                >
                                                  <Grid item style={{ flex: 1 }}>
                                                    <input
                                                      disabled={type === "view"}
                                                      placeholder="Select Input Type"
                                                      className={style.optionInput}
                                                      value={type === "view" ? props.parameters[index].inputType : inputType}
                                                      onChange={(e) => { setInputType(e.target.value); setInputTypeError({ error: false, errorMsg: "" }) }}
                                                    />
                                                  </Grid>
                                                  <Grid item> {isInputTypeDropDown ? <UpArrow /> : <DownArrow />} </Grid>
                                                </Grid>
                                                {isInputTypeDropDown && (
                                                  <div className={classes.dropdown} style={{ zIndex: 2000 }}>
                                                    {inputTypeOptions.map((option, index) => {
                                                      return (
                                                        <Grid item className={style.option} key={index}
                                                          onClick={() => {
                                                            handleInputTypeChange(option)
                                                            setIsInputTypeDropDown(!isInputTypeDropDown)
                                                          }}
                                                        >
                                                          {option}
                                                        </Grid>
                                                      )
                                                    })
                                                    }
                                                  </div>
                                                )}
                                                <Typography className={style.errorText}>{inputTypeError.errorMsg}</Typography>
                                              </Grid>
                                            </FormControl>
                                          </Grid>
                                          <Grid item xs={6} md={6} style={{
                                            textAlign: "left", paddingBottom: "20px"
                                          }}>
                                            <Typography className={style.label}>Data format<span className={style.required}>*</span></Typography>
                                            <FormControl className={style.input}>
                                              <Grid container style={{ height: '40px' }}>
                                                <Grid container className={style.formInput}
                                                  style={{ cursor: 'pointer' }}
                                                  alignContent="center"
                                                  onClick={() => { if (parameterToCreate||type=="edit") { setIsFormatDropDown(!isFormatDropDown) } }}
                                                >
                                                  <Grid item style={{ flex: 1 }}>
                                                    <input
                                                      disabled={type === "view"}
                                                      placeholder="Select Format Type"
                                                      className={style.optionInput}
                                                      value={type === "view" ? props.parameters[index].format : format}
                                                      onChange={(e) => setFormat(e.target.value)}
                                                    />
                                                  </Grid>
                                                  <Grid item> {isFormatDropDown ? <UpArrow /> : <DownArrow />} </Grid>
                                                </Grid>
                                                {isFormatDropDown && (
                                                  <div className={classes.dropdown} style={{ zIndex: 2000 }}>
                                                    {formatOptions.map((option, index) => {
                                                      return (
                                                        <Grid item className={style.option} key={index}
                                                          onClick={() => {
                                                            handleFormatChange(option)
                                                            setIsFormatDropDown(!isFormatDropDown)
                                                          }}
                                                        >
                                                          {option}
                                                        </Grid>
                                                      )
                                                    })
                                                    }
                                                  </div>
                                                )}
                                              </Grid>
                                            </FormControl>
                                            <Typography className={style.errorText}>{formatError.errorMsg}</Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            xs={6}
                                            md={6}
                                            style={{ textAlign: "left", paddingBottom: "20px" ,paddingLeft:"20px"}}
                                          >
                                            <Typography className={style.label}>Default Value<span className={style.required}>*</span> &nbsp;
                                            </Typography>
                                            <FormControl className={style.input}>
                                              <input
                                                className={style.formInput}
                                                disabled={type === "view" || format === ""}
                                                onChange={(e) => {
                                                  setDefaultVal(e.target.value);
                                                  if (format == "Char" && e.target.value.length > 1) {
                                                    setDefaultValueError({ error: true, errorMsg: "Cannot add more than 1 character" })
                                                  }
                                                  else {
                                                    setDefaultValueError({ error: false, errorMsg: "" })
                                                  }
                                                }}
                                                value={
                                                  type === "view"
                                                    ? props.parameters[index].defaultValue
                                                    : defaultVal
                                                }
                                              />
              
                                            </FormControl>
                                            {defaultValueError.error && (
                                              <Typography className={style.errorText}>
                                                {defaultValueError.errorMsg}</Typography>
                                            )}
                                          </Grid>
              
                                          <Grid item xs={12} md={12} style={{ textAlign: "left", paddingBottom: "20px"}}>
                                            <Typography className={style.label}>Join Parameter</Typography>
                                            <FormControl className={style.input}>
                                              <Select
                                                disabled={type === "view" ? true : false}
                                                id="demo-customized-select-native"
                                                value={
                                                  type === "view" ? props.parameters[index].joinParameter : join
                                                }
                                                className={style.input}
                                                onChange={selectJoin}
                                                multiple
                                                MenuProps={{
                                                  anchorOrigin: {
                                                    vertical: "bottom",
                                                    horizontal: "left",
                                                  },
                                                  transformOrigin: {
                                                    vertical: "top",
                                                    horizontal: "left",
                                                  },
                                                  getContentAnchorEl: null,
                                                }}
                                                renderValue={(selected: string[]) => (
                                                  <div>
                                                    {selected.map((value, i) => (
                                                      <Chip
                                                        key={i}
                                                        label={value}
                                                        className={style.chip}
                                                        onMouseDown={(event) => {
                                                          event.stopPropagation();
                                                        }}
                                                        onDelete={() => removeJoin(value)}
                                                      />
                                                    ))}
                                                  </div>
                                                )}
                                                input={<BootstrapInput />}
                                              >
                                                {type === "add-new" ? (
                                                  props.parameters
                                                    .filter((obj) => obj.parameterCategory === mainType)
                                                    .map((p, j) => {
                                                      return (
                                                        <MenuItem value={p.parameterId} key={j}>
                                                          <ListItemText
                                                            primary={p.parameterId}
                                                            style={{ color: primaryGray }}
                                                          />
                                                        </MenuItem>
                                                      );
                                                    })
                                                ) : type === "edit" ? (
                                                  props.parameters
                                                    .filter((obj) => obj.parameterCategory === mainType)
                                                    .filter((ob) => ob.parameterId !== props.parameters[index].parameterId)
                                                    .map((p, j) => {
                                                      return (
                                                        <MenuItem value={p.parameterId} key={j}>
                                                          <ListItemText
                                                            primary={p.parameterId}
                                                            style={{ color: primaryGray }}
                                                          />
                                                        </MenuItem>
                                                      );
                                                    })
                                                ) : (
                                                  <div></div>
                                                )}
                                              </Select>
                                            </FormControl>
                                          </Grid>
                                        </Grid>} */}

          {/* {addCommand && (
            <Grid container style={{ textAlign: "center", marginTop: "20px" }}>
              <Grid item xs={6} style={{ textAlign: "left", paddingBottom: "20px" }}>
                <Typography className={style.typo}>Command name<span className={style.required}>*</span> </Typography>
                {type === "edit" ? (

                  <input
                    disabled
                    className={style.formInput}
                    value={props.parameters[index].parameter}
                  />
                ) :
                  <input
                    disabled={type === "add-new" ? false : true}
                    className={style.formInput}
                    onChange={(e) => setParameter(e.target.value)}
                    value={parameter}
                  />
                }
                {parameterError.error && (
                  <Typography className={style.errorText}>{parameterError.errorMsg}</Typography>)}
              </Grid>
              <Grid item xs={6} md={6} style={{ textAlign: "left", paddingBottom: "20px", paddingLeft: "20px" }}>
                <Typography className={style.typo}>Command ID<span className={style.required}>*</span></Typography>
                <FormControl className={style.input}>
                  {type === "edit" ? (
                    <Tooltip title="Parameter ID cannot be edited once saved" arrow>
                      <input
                        disabled
                        className={style.formInput}
                        type="number"
                        value={props.parameters[index].parameterId}
                      />
                    </Tooltip>
                  ) : (
                    <input
                      className={style.formInput}
                      disabled={type === "add-new" ? false : true}
                      type="number"
                      value={id}
                      onChange={(e) => {
                        setId(e.target.value);
                        setIdError({ error: false, errorMsg: "" });
                      }}
                    />
                  )}
                </FormControl>
                {idError.error && (
                  <Typography className={style.errorText}>{idError.errorMsg}</Typography>)}
              </Grid>
              <Grid
                item
                xs={6}
                md={6}
                style={{ textAlign: "left", paddingBottom: "20px" }}
              >
                <Typography className={style.label}>Input Type<span className={style.required}>*</span></Typography>
                <FormControl className={style.input}>
                  <Grid container style={{ height: '40px' }}>
                    <Grid container className={style.formInput}
                      style={{ cursor: 'pointer' }}
                      alignContent='center'
                      onClick={() => { setIsInputTypeDropDown(!isInputTypeDropDown) }}
                    >
                      <Grid item style={{ flex: 1 }}>
                        <input
                          disabled={type === "view"}
                          placeholder="Select Input Type"
                          className={style.optionInput}
                          value={type === "view" ? props.parameters[index].inputType : inputType}
                          onChange={(e) => { setInputType(e.target.value); setInputTypeError({ error: false, errorMsg: "" }) }}
                        />
                      </Grid>
                      <Grid item> {isInputTypeDropDown ? <UpArrow /> : <DownArrow />} </Grid>
                    </Grid>
                    {isInputTypeDropDown && (
                      <div className={classes.dropdown} style={{ zIndex: 2000 }}>
                        {inputTypeOptions.map((option, index) => {
                          return (
                            <Grid item className={style.option} key={index}
                              onClick={() => {
                                handleInputTypeChange(option)
                                setIsInputTypeDropDown(!isInputTypeDropDown)
                              }}
                            >
                              {option}
                            </Grid>
                          )
                        })
                        }
                      </div>
                    )}
                    <Typography className={style.errorText}>{inputTypeError.errorMsg}</Typography>
                  </Grid>
                </FormControl>
              </Grid>
              <Grid item xs={6} md={6} style={{
                textAlign: "left", paddingBottom: "20px", paddingLeft: "20px"
              }}>
                <Typography className={style.label}>Data format<span className={style.required}>*</span></Typography>
                <FormControl className={style.input}>
                  <Grid container style={{ height: '40px' }}>
                    <Grid container className={style.formInput}
                      style={{ cursor: 'pointer' }}
                      alignContent="center"
                      onClick={() => { setIsFormatDropDown(!isFormatDropDown) }}
                    >
                      <Grid item style={{ flex: 1 }}>
                        <input
                          disabled={type === "view"}
                          placeholder="Select Format Type"
                          className={style.optionInput}
                          value={type === "view" ? props.parameters[index].format : format}
                          onChange={(e) => setFormat(e.target.value)}
                        />
                      </Grid>
                      <Grid item> {isFormatDropDown ? <UpArrow /> : <DownArrow />} </Grid>
                    </Grid>
                    {isFormatDropDown && (
                      <div className={classes.dropdown} style={{ zIndex: 2000 }}>
                        {formatOptions.map((option, index) => {
                          return (
                            <Grid item className={style.option} key={index}
                              onClick={() => {
                                handleFormatChange(option)
                                setIsFormatDropDown(!isFormatDropDown)
                              }}
                            >
                              {option}
                            </Grid>
                          )
                        })
                        }
                      </div>
                    )}
                  </Grid>
                </FormControl>
                <Typography className={style.errorText}>{formatError.errorMsg}</Typography>
              </Grid>
              <Grid
                item
                xs={6}
                md={6}
                style={{ textAlign: "left", paddingBottom: "20px" }}
              >
                <Typography className={style.label}>Command Value<span className={style.required}>*</span> &nbsp;
                  <Tooltip
                    arrow
                    title={
                      <React.Fragment>
                        <Grid container>
                          <Grid item xs={12} md={12}>
                            <Typography
                              style={{ fontSize: "12px", color: '#FFFFFF', fontWeight: 300, fontFamily: 'poppins' }}
                            >{"Use curly braces {} to specify values that vary by device. For example, "}<br />
                              {"S2D/SA/VA/{deviceId}"}
                            </Typography>
                          </Grid>
                        </Grid>
                      </React.Fragment>
                    }
                    interactive
                    placement="right"
                  >
                    <IconButton style={{ padding: "1px 2px 2px 0px" }}>
                      <QuestionIcon />
                    </IconButton>
                  </Tooltip>
                </Typography>
                <FormControl className={style.input}>
                  <input
                    className={style.formInput}
                    disabled={type === "view" || format === ""}
                    onChange={(e) => {
                      setDefaultVal(e.target.value);
                      if (format == "Char" && e.target.value.length > 1) {
                        setDefaultValueError({ error: true, errorMsg: "Cannot add more than 1 character" })
                      }
                      else {
                        setDefaultValueError({ error: false, errorMsg: "" })
                      }
                    }}
                    value={
                      type === "view"
                        ? props.parameters[index].defaultValue
                        : defaultVal
                    }
                  />

                </FormControl>
                {defaultValueError.error && (
                  <Typography className={style.errorText}>
                    {defaultValueError.errorMsg}</Typography>
                )}
              </Grid>
                <Grid item xs={6} md={6} style={{
                textAlign: "left", paddingBottom: "20px", paddingLeft: "20px"
              }}>
                <Typography className={style.label}>Command type<span className={style.required}>*</span></Typography>
                <FormControl className={classes.input}>
                  <DropDownRMOTA
                    isSingle={true}
                    options={commandTypeOptions}
                    type="commandType"
                    placeholder="Select Command Type"
                    value={type === "view" ? props.parameters[index].commandType : commandType}
                    setSelectValue={(e) => setCommandType(e.target.value)}
                    disabled={type === "view"}
                    onClick={handleCommandTypeSelect}

                  />
                </FormControl>
                <Typography className={style.errorText}>{formatError.errorMsg}</Typography>
              </Grid>


            </Grid>

          )} */}
            {/* </DialogContent> */}
            {/* {type !== "view" && (
              <DialogActions style={{ width: "100%" }} hidden>
                <Button
                  variant="contained"
                  className={style.cancel}
                  onClick={closeAddParameter}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  className={style.add}
                  disabled={type === "view" ? true : false}
                  onClick={() => {

                    readParameters({
                      parameterCategory: mainType,
                      parameter: parameter,
                      parameterId: id,
                      inputType: inputType,
                      format: format,
                      joinParameter: join,
                      defaultValue: defaultVal,
                      label:label,
                      isCommand: addCommand ? true : false,
                      commandType:commandType
                    });
                  }}
                >
                  {type === "edit" ? "Update" : "Save"}
                </Button>
              </DialogActions>
            )} */}
          {/* </Dialog>
        </>
      ) : ""} */}

      {loadingScreen &&
        <div style={{
          position: 'fixed',
          left: 0,
          top: 0,
          backgroundColor: '#000000',
          opacity: 0.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          width: '100vw',
          height: '100vh'
        }}>
          <CircularProgress size={80} />
        </div>}
        <Snackbar
        open={open}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert severity={reqSuccess === true ? "success" : "warning"}>
          <h3 style={{ textAlign: "left" }}>
            {reqSuccess === true ? "Success" : "Error"}
          </h3>
          {reqSuccess
            ? (successMessage.length>0?successMessage:"Success")
            : errorMessage.length > 0
              ? errorMessage
              : "Something Went Wrong"}
        </Alert>
      </Snackbar>
      <PromptDialog openDialog={openPrompt} setOpenDialog={setOpenPrompt}  OKText={"Ok"}  title={"Device Configuration Needed"} description={topicError} />
     
      <UpgradePopup
        open={upgradePopup.open}
        onClose={() => setUpgradePopup({...upgradePopup, open: false})}
        onUpgrade={() => {
          setUpgradePopup({...upgradePopup, open: false});
          window.open(environment.azurepageLink);
        }}
        featureName={upgradePopup.featureName}
        onCloseWithFeature={() => {
          setUpgradePopup({...upgradePopup, open: false});
          if (upgradePopup.featureName === 'Remote Manager') {
            props.setUpdatedRemotelyConfigurable(!props.updatedRemotelyConfigurable);
          } else if (upgradePopup.featureName === 'OTA') {
            props.setUpdatedOtaUpgradable(!props.updatedOtaUpgradable)
          }
        }}
      />
    </div>
  );
};
export default function PromptDialog(props) {
  const buttonColor=props.severity&&props.severity=="danger"?primaryRed:primaryBlue;
  
  const handleClose=()=>{
  props.setOpenDialog(false)}
  return(
  <Dialog
  open={props.openDialog}
  onClose={handleClose}
  aria-labelledby="alert-dialog-title"
  aria-describedby="alert-dialog-description"
>
  <DialogTitle id="alert-dialog-title">
    {props.title}
  </DialogTitle>
  <DialogContent>
    <DialogContentText id="alert-dialog-description">
    {props.description}
    </DialogContentText>
  </DialogContent>
  <DialogActions>
    <Button onClick={handleClose}  style={{backgroundColor:buttonColor,color:"white"}}>{props.OKText?props.OKText:"OK"}</Button>
  </DialogActions>
</Dialog>)
}
const useLocalStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingTop: "20px",
  },
  input: {
    width: "100%",
    textAlign: "left",
  },
  textBarStyle: {
    height: "38px",
    borderRadius: "5px",
    border: "1px solid black",
  },
  popup: {
    backgroundColor: "#CEEBCE",
  },
  formInput: {
    height: "38px",
    borderRadius: "5px",
    padding: "10px 15px",
    fontFamily: "'Poppins', sans-serif",
    border: '0.5px solid',
    backgroundColor: white,
    fontSize: "13px",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  configDevicesButton: {
    backgroundColor: white,
    color: primaryBlue,
    borderColor:primaryBlue,
    borderStyle:"solid",
    borderWidth:"1px",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: primaryBlue,
      color: white,
      boxShadow: "none",
    },
  },
  gridStyle: {
    textAlign: "left",
    marginBottom: "25px",
    paddingRight: "2%",
  },
  labelStyle: {
    fontFamily: "Poppins",
    fontSize: "15px",
    lineHeight: "25px",
  },

  dropdown: {
    textAlign: 'left',
    border: '0.5px solid #324054',
    margin: 'px',
    borderRadius: '5px',
    backgroundColor: white,
    width: '100%',
    zIndex: 1,
    maxHeight: '160px',
    overflowY: 'auto',
  },
  option: {
    paddingLeft: '10px',
    height: '30px',
    "&:hover": {
      backgroundColor: primaryBlue,
      color: white,
      boxShadow: "none",
    },
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    fontSize: "13px"
  },
  dropDownGrid: {
      backgroundColor: white,
      border: '1px solid #C7C4C4',
      borderRadius: '5px',
      maxHeight: '200px',
      overflowY: 'auto',
      marginTop: '40px',
      zIndex:10,
      position: 'absolute'
    },
    addIcon:{
      margin: "5px 0px 0px 10px",
      display: 'flex', 
      alignItems: 'center', 
      cursor: 'pointer'
    }
}));


const BootstrapInput = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "label + &": {
        marginTop: theme.spacing(3),
      },
    },

    input: {
      borderRadius: 4,
      position: "relative",
      backgroundColor: "white",
      border: "1px solid #ced4da",
      fontSize: 16,
      padding: "10px 26px 10px 12px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
      "&:focus": {
        borderRadius: 4,
        borderColor: searchBarBorderColor,
        backgroundColor: "white",
      },
    },
  })
)(InputBase);
